<template>
  <div>
    <a-modal
      title="Edit SignetRep"
      :visible="bookReqSales !== null"
      :maskClosable="false"
      @cancel="handleContactRepModalCancel"
    >
      <a-form layout='horizontal' :form="formRep" class="contactInfoBox">
        <a-form-item
          label="Signet Rep"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            placeholder=""
          >
            <a-select-option value="a">alan.cheng</a-select-option>
            <a-select-option value="b">alice.li</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-popconfirm
          title="Are you sure?"
          @confirm="handleContactRepModalConfirm"
          ok-text="Yes" 
          cancel-text="No"
        >
          <a-button type="primary">Confirm</a-button>
        </a-popconfirm>
      </template>
    </a-modal>
  </div>
</template>

<script>

export default {
  name: 'ContactRep',
  components: {
  },
  props: {
    bookReqSales: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 24 }
        }
      },
      showContactModal:false,
      formRep: this.$form.createForm(this)
    }
  },
  mounted () {
  },
  methods: {
    handleContactRepModalCancel () {
      this.$emit('cancel')
    },
    handleContactRepModalConfirm () {
       this.$emit('confirm')
    }
  }
}
</script>
<style lang="less" scoped>
</style>